export const ONE_DAY_IN_MS = 86400000;
export const ONE_AND_A_HALF_SECONDS_IN_MS = 1500;
export const TWO_SECONDS_IN_MS = 2000;
export const THREE_SECONDS_IN_MS = 3000;
export const ONE_HOUR_IN_MS = 1000 * 60 * 60;

export const FOUR_SECONDS_IN_MS = 4000;
export const TEN_SEC_IN_MS = 10000;
export const THIRTY_SEC_IN_MS = 30000;

export const FIVE_MIN_IN_MS = 300000;
export const ONE_YEAR_FROM_NOW = Date.now() + 365 * ONE_DAY_IN_MS;
